import { saveScrapDataAndGetResult } from "@/api/niceTax";
import { doScrap } from "@/api/infotech";
import { getSample } from "@/api/niceTax";

const sendStore = {
    namespaced: true,
    state: {
        scrapRequest: {},   // 스크래핑 요청값
        scrapData: {},        // 스크래핑 원본값
        scrapResult: {},    // 스크래핑 데이터 서버 전송 후 처리 결과값
    },
    getters: {
        scrapRequest(state) {
            return state.scrapRequest;
        },
        scrapData(state) {
            return state.scrapData;
        },
        scrapResult(state) {
            return state.scrapResult;
        },
        applyInfo(state, getters, rootState) {
            return rootState.sessionStore.applyInfo;
        }
    },
    mutations: {
        ADD_SCRAP_REQUEST(state, scrapRequest) {
            Object.assign(state.scrapRequest, scrapRequest);
        },
        ADD_SCRAP_DATA(state, scrapData) {
            Object.assign(state.scrapData, scrapData);
        },
        SET_SCRAP_RESULT(state, scrapResult) {
            state.scrapResult = scrapResult;
        },
    },
    actions: {
        SAVE_SCRAPING_DATA({ commit }, data) {
            commit("ADD_SCRAP_DATA", data);
        },

        /**
         * 개별 항목 스크래핑용 함수
         * [홈택스]
         *  - NT2-2: 세금신고 결과조회
         *  - NT4: 전자(세금)계산서 합계표
         *  - NT2, NT3, NT5, NT6, NT7: 증명발급
         * [위택스]
         *  - NT8
         * [건강보험공단(nhic)]
         *  - NT9
         */
        async SCRAP_AND_SET_DATA({ commit, state, rootState }, params) {
            // 서버 전송값에서는 인증서 관련 변수 제거
            const requestJson = { ...params.inJson };
            if (requestJson.hasOwnProperty("signCert")) {
                delete requestJson["signCert"]
            }
            if (requestJson.hasOwnProperty("signPri")) {
                delete requestJson["signPri"]
            }
            if (requestJson.hasOwnProperty("signPw")) {
                delete requestJson["signPw"]
            }
            if (requestJson.hasOwnProperty("userPw")) {
                delete requestJson["userPw"]
            }
            if (requestJson.hasOwnProperty("agentPw")) {
                delete requestJson["agentPw"]
            }
            // 요청값 스토어 저장(향후 서버 전송)
            commit("ADD_SCRAP_REQUEST", { [params.code]: requestJson });

            // 스크래핑
            const scrapData = {};
            try {
                if (process.env.NODE_ENV === 'production') {
                    const { data } = await doScrap(params.inJson);
                    scrapData.data = JSON.stringify(data);
                } else {
                    const { data } = await getSample({
                        fileName: `${rootState.sessionStore.applyInfo.sendType}_${params.inJson.bizNo.replaceAll("-", "")}_${params.code}.json`
                    });
                    scrapData.data = JSON.stringify(data.data);
                }
            } catch (error) {
                console.error(error);
                scrapData.error = error.message;
            }

            // 스크래핑 결과값 스토어 저장
            commit("ADD_SCRAP_DATA", { [params.code]: scrapData });
        },

        /**
         * 스크래핑 결과물 서버에 전송 및 DB 저장
         */
        async SEND_SCRAP_DATA_AND_GET_RESULT({ commit, state, rootState }, isResent) {
            const param = {
                scrapRequest: state.scrapRequest,
                scrapData: state.scrapData,
                applyInfo: rootState.sessionStore.applyInfo,
                accessInfo: rootState.sessionStore.accessInfo,
                bizInfo: rootState.sessionStore.bizInfo,
                isResent: isResent,
            };
            const { data } = await saveScrapDataAndGetResult(param);
            commit("SET_SCRAP_RESULT", data.data);
        },

        CLEAR_SCRAP_REQUEST({ commit, state }) {
            for (const code in state.scrapRequest) {
                if (code != "NT1") {
                    delete state.scrapRequest[code];
                }
            }
        },

        CLEAR_SCRAP_DATA({ commit, state }) {
            for (const code in state.scrapData) {
                if (code != "NT1") {
                    delete state.scrapData[code];
                }
            }
        },
    },


};

export default sendStore; 